import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as outlookAgentModeButton from "./OutlookAgentModeButton";

/**
 * Lazy wrapper for the Agent Mode ribbon button. Splits the button's heavy dependencies
 * (the AugLoop/BizChat bridge, Fluent v9, the Copilot icon) into an on-demand chunk so they
 * are NOT in the mail boot bundle — everyone used to pay for them on boot regardless of the
 * flight. Rendered only when the agentModeIframe flight is on (gated at the ribbon call site),
 * so flight-off users never fetch the chunk. Mirrors owa-copilot-dab's LazyCopilotDab.
 */
const lazyModule: LazyModule<typeof outlookAgentModeButton> = new LazyModule(() => import(/* webpackChunkName: "OutlookAgentModeButton" */ "./OutlookAgentModeButton"), { name: "OutlookAgentModeButton" });

export const LazyOutlookAgentModeButton: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.OutlookAgentModeButton);
